import React from 'react'
import PropTypes from 'prop-types'
import {ListItemPrimaryText as RmwcListItemPrimaryText} from '@rmwc/list'
import '@rmwc/list/styles'

const ListItemPrimaryText = ({children, ...otherProps}) => <RmwcListItemPrimaryText {...otherProps}>{children}</RmwcListItemPrimaryText>

ListItemPrimaryText.propTypes = {
  children: PropTypes.any
}

export {ListItemPrimaryText}
